// Opens a URL in a new tab with no `window.opener`, so the opened page cannot navigate this one.
// Returns the new window handle (null when the browser blocked the popup).
let open_in_new_tab = (url) => {
  let opened = window.open(url, '_blank');
  if (opened) { opened.opener = null; }
  return opened;
}

export default {
  openInNewTab: open_in_new_tab
}
